import React from 'react';
import type { PillGlyph } from '../../types';
import { parseEm } from './parseEm';
import '../../styles/highlight/HighlightPill.css';

interface HighlightPillProps {
  glyph: PillGlyph;
  label: string;
  value: string;
  index: number;
}

const GLYPH_PATHS: Record<PillGlyph, React.ReactNode> = {
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 9h18M8 3v4M16 3v4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  pin: (
    <>
      <path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z" />
      <circle cx="12" cy="9" r="2.5" />
    </>
  ),
  price: (
    <>
      <path d="M12 3v18M7 7h8a3 3 0 010 6H9a3 3 0 000 6h8" />
    </>
  ),
  paw: (
    <>
      <circle cx="6" cy="9" r="2" />
      <circle cx="10" cy="5" r="2" />
      <circle cx="14" cy="5" r="2" />
      <circle cx="18" cy="9" r="2" />
      <path d="M8 18c0-3 2-5 4-5s4 2 4 5-2 3-4 3-4 0-4-3z" />
    </>
  ),
  envelope: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="1" />
      <path d="M3 7l9 7 9-7" />
    </>
  ),
  heart: <path d="M12 21s-7-4.35-7-10a4 4 0 017-2.65A4 4 0 0119 11c0 5.65-7 10-7 10z" />,
  phone: (
    <path d="M5 4h3l2 5-2 1a11 11 0 005 5l1-2 5 2v3a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />
  ),
};

const HighlightPill: React.FC<HighlightPillProps> = ({ glyph, label, value, index }) => (
  <div className="psl-hl-pill" data-index={index}>
    <span className="psl-hl-pill__glyph" aria-hidden="true">
      <svg viewBox="0 0 24 24">{GLYPH_PATHS[glyph]}</svg>
    </span>
    <span className="psl-hl-pill__body">
      <span className="psl-hl-pill__lbl">{label}</span>
      <span className="psl-hl-pill__val">{parseEm(value)}</span>
    </span>
  </div>
);

export default HighlightPill;
